<template lang="html">
    <div :class="[{ 'opacity-background': show }]">
        <!-- <div> -->
        <header>
            <div class="navbar-fixed">
                <nav class="header-supplier-mobile">
                    <div @click="$emit('show')" :class="['nav-icon', { open: show }]">
                        <div></div>
                    </div>
                    <a
                        @click="$emit('push-route', { url: 'CompetitionDashboard', solo: false })"
                        class="brand-logo-supplier-mobile"
                    >
                        <img src="@/assets/images/engelink_logo.svg" class="center-element" alt="Engelink" />
                    </a>
                </nav>
            </div>
            <div :class="['side-bar-mobile', { show: show }]">
                <ul>
                    <div v-show="planType.length">
                        <div class="supplier-info-mobile">
                            <div class="btn-hat-mobile">
                                <i class="icon-hard-hat-mobile fas fa-hard-hat"></i>
                            </div>
                            <div class="supplier-name-mobile">
                                <b>{{ supplierName }}</b>
                                <div class="plan-type-mobile ">
                                    {{ planType }}
                                </div>
                            </div>
                        </div>
                        <div class="money-info-mobile">
                            <div v-show="bonus != '0'" class="bonus-value-mobile">
                                <b class="value-mobile">{{ convertNumberToBRLLocal(bonus) }}</b>
                                <div class="bonus-title-mobile">Bônus</div>
                            </div>
                            <div v-show="bonus != '0'" class="division"></div>
                            <div v-show="coins != '0'" class="coins-value-mobile">
                                <b class="value-mobile">{{ convertNumberToBRLLocal(coins) }}</b>
                                <div class="coins-title-mobile">
                                    Moedas
                                </div>
                            </div>
                            <div 
                                v-show="useCreditCardCountdown != 0" 
                                class="countdown-mobile"
                                :content="useCreditCardCountdownText"
                                v-tippy="{placement : 'bottom',  arrow: true}"
                            >
                                <b class="value-mobile">
                                     <countdown :time="useCreditCardCountdown" @end="onUseCreditCardCountdownEnd">
                                        <template slot-scope="props">
                                            {{ numberWithPaddingZeros(props.hours) }}:
                                            {{ numberWithPaddingZeros(props.minutes) }}:
                                            {{ numberWithPaddingZeros(props.seconds) }}
                                        </template>
                                    </countdown>
                                </b>
                                <div class="countdown-title-mobile">Próxima compra em</div>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                    <li @click="$emit('push-route', { url: 'https://salesfeed.ai/', solo: true });$emit('show')">
                        <a id="new-mobile">
                            <span class="title-mobile">
                                Inteligência Artificial
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('set-supplier');$emit('show')">
                        <a>
                            <span class="title-mobile" style="color: #0173cd">
                                Engelink Crédito
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'https://condo.news/', solo: true });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                CondoNews
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Materiais
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('showModal');$emit('show')">
                        <a>
                            <span class="notification-item title-mobile">
                                <span>Notificações</span>
                                <span v-if="userNotification > 0" class="notification-count">{{userNotification}}</span>
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'BalancePurchase', solo: false });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Pacote de moedas
                            </span>
                        </a>
                    </li>
                    <li v-show="!planType.length" @click="$emit('openSubscriptionAlertModal');$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Planos
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'ContactUs', solo: false });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Fale conosco
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'EditProfileSupplier', solo: false });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Editar perfil
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('push-route', { url: 'Home', solo: false });$emit('show')">
                        <a>
                            <span class="title-mobile">
                                Alterar perfil
                            </span>
                        </a>
                    </li>
                    <li @click="$emit('logout')">
                        <a>
                            <span class="title-mobile">
                                Sair
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    </div>
</template>

<script>
import { numberWithPaddingZeros } from '@/utils/filters';
import { mapActions } from 'vuex';

export default {
    name: 'HeaderSupplierMobile',
    props: {
        coins: String,
        bonus: String,
        supplierName: String,
        planType: String,
        show: Boolean,
        useCreditCardCountdown: Number,
        userNotification: Number
    },
    data() {
        return {
            useCreditCardCountdownText: 'Tempo restante para sua próxima participação em cotações.'
        };
    },
    methods: {
        ...mapActions('user', ['setUserCountdown']),
        numberWithPaddingZeros,
        convertNumberToBRLLocal(value) {
            const number = value.split(',');
            number[0] = 'R$ ' + number[0].split(/(?=(?:...)*$)/).join('.');
            return number.join(',');
        },
        onUseCreditCardCountdownEnd() {
            this.setUserCountdown();
        }
    }
};
</script>

<style lang="scss">
li {
    list-style-type: none;
}
.header-supplier-mobile {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    z-index: 999 !important;
    box-shadow: 0px 3px 6px #00000029;
}
nav .brand-logo-supplier-mobile {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    height: 54px;
    justify-content: center;
    width: 150px;
}
nav .brand-logo-supplier-mobile img {
    max-height: 40px;
    max-width: 150px;
}
/* Tracinho de cima */
.nav-icon:before {
    width: 35px;
}
/* // Tracinho do meio */
.nav-icon {
    /* // margin: 1em; */
    left: 0;
    position: fixed;
    width: 30px;
    margin-left: 25px;
    align-self: center;
}
/* // Tracinho de baixo */
.nav-icon:after {
    width: 25px;
}
.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #003f7e;
    border-radius: 3px;
    content: '';
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
/* // largura quando o menu está aberto */
.nav-icon.open:after,
.nav-icon.open:before,
.nav-icon.open {
    width: 20px !important;
    margin: 8px 13px !important;
}
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
.supplier-info-mobile {
    display: block;
    margin-left: 22px;
    width: 85%;
    background-color: #f4f4f4;
    border: 2px solid #f4f4f4;
    border-radius: 5px 5px 5px 5px;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 5px 12px;
}
.btn-hat-mobile {
    display: flex;
    align-self: flex-start;
    font-size: 30px;
    width: 35px;
    height: 35px;
    background-color: #0173cd;
    border: 2px solid #0173cd;
    border-radius: 5px 5px 5px 5px;
}
.icon-hard-hat-mobile {
    color: #fff;
    display: flex;
    align-items: center;
    position: relative;
    left: 0.8px;
    bottom: 1px;
}
.supplier-name-mobile {
    margin-left: 11px;
    font-size: 13px;
}

.supplier-name-mobile b {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.plan-type-mobile {
    font-size: 13px;
    color: #707070;
}
.money-info-mobile {
    white-space: nowrap;
    margin-top: 13px;
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
    flex-wrap: wrap;
}
.division {
    border-right: 1px solid #a5a5a588;
    margin-inline: 16px;
}
.value-mobile {
    color: #62727b;
    font-size: 15px;
}
.bonus-title-mobile,
.countdown-title-mobile,
.coins-title-mobile {
    font-size: 8px;
    color: #a5a5a5;
    display: flex;
    justify-content: center;
}

.countdown-mobile {
    width: 60%;
    text-align: center;
    padding-top: 5px;
    border-top: 1px solid #ccc;
    margin-top: 15px;
}

.side-bar-mobile {
    position: fixed;
    height: 100%;
    width: 0%;
    z-index: 9999 !important;
    background-color: #fff;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    box-shadow: black;
    box-shadow: inset 0 5px 9px -7px rgb(0 0 0 / 70%);
}
.side-bar-mobile ul {
    /* // position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
}
.side-bar-mobile ul li {
    position: relative;
    width: 100%;
    list-style: none;
}
.side-bar-mobile ul li a {
    position: relative;
    display: block;
    width: 100%;
    /* // display: flex; */
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 16px;
    color: #707070;
}
.side-bar-mobile ul li a .title-mobile {
    position: relative;
    display: block;
    text-align: start;
    white-space: nowrap;
    padding: 0 10px;
}

.side-bar-mobile.show {
    width: 80%;
}
/* efeito de opacidade do menu de fornecedor na versão mobile */
.opacity-background {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    display: table;
    transition: 0.5s;
    overflow: hidden;
}
.notification-item {
    display: flex !important;
    justify-content: start;
    gap: 10px;
    align-items: center;
}
.notification-count {
    background-color: red;
    display: flex;
    align-content: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    color: #fff;
    font-weight: bold;
    line-height: 20px;
}

@media screen and (min-width: 480px) {
    .countdown-mobile {
        width: 80%;
        text-align: center;
        padding-top: 5px;
        border-top: 1px solid #ccc;
        margin-top: 15px;
    }
}

#new-mobile {
    position: relative;
}
#new-mobile::before {
content: "Novo";
    padding: 2px;
    background-color: red;
    position: absolute;
    top: 6px;
    left: 180px;
    font-size: 10px;
    color: #fff;
    width: auto;
    height: auto;
    line-height: 11px;
    border-radius: 4px;
    margin: 0px;
}
</style>
